export default __webpack_public_path__ + "static/media/carbiz-logo.bbcde509.svg";